"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Search = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    searchTerm,
    setSearchTerm
  } = (0, _contexts.usePickupPoints)();
  const onSearch = (0, _react.useCallback)(event => setSearchTerm(event.target.value), [setSearchTerm]);
  const onClear = (0, _react.useCallback)(() => setSearchTerm(''), [setSearchTerm]);
  const searchInputSlotProps = (0, _react.useMemo)(() => ({
    input: {
      startAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputAdornment, {
        position: "start",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.MapPin, {
          fontSize: "small"
        })
      }),
      endAdornment: searchTerm ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputAdornment, {
        position: "end",
        onClick: onClear,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
          fontSize: "small"
        })
      }) : null
    }
  }), [onClear, searchTerm]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_models.TestId.SelectPickupPointDialogSearch),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchInput, {
      variant: "filled",
      color: "primary",
      slotProps: searchInputSlotProps,
      placeholder: formatMessage('deliverySearchPickupPointsPlaceholder'),
      value: searchTerm,
      onChange: onSearch
    })
  });
};
exports.Search = Search;